import React from "react";
import {Grid} from "@mui/material";

export default ({children,sx}) => {
    return <Grid container width={1} flex={1} alignItems={"center"} flexDirection={"column"} justifyContent={"center"}sx={sx}>
        {children}
    </Grid>
}
